import { render, staticRenderFns } from "./total.vue?vue&type=template&id=747ce056&"
import script from "./total.vue?vue&type=script&lang=js&"
export * from "./total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747ce056')) {
      api.createRecord('747ce056', component.options)
    } else {
      api.reload('747ce056', component.options)
    }
    module.hot.accept("./total.vue?vue&type=template&id=747ce056&", function () {
      api.rerender('747ce056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/total.vue"
export default component.exports